import React from "react";
import HairstylingOn from "../HairstylingOn";
import BridalMakeup from "../BridalMakeup";
import PartyMakeup from "../PartyMakeup";
import Offers from "../Offers";
import Group222 from "../Group222";
import HairStyling from "../HairStyling";
import BridalMakeupOn from "../BridalMakeupOn";
import PartyMakeupOn from "../PartyMakeupOn";
import OffersOn from "../OffersOn";
import "./Property1Default.css";

function Property1Default(props) {
  const {
    hairStyling,
    rectangle115,
    asMakeupPlaysAnI1,
    sohniJunejaIsARe1,
    bridalMakeup,
    rectangle121,
    asMakeupPlaysAnI2,
    sohniJunejaIsARe2,
    partyMakeup,
    rectangle127,
    asMakeupPlaysAnI3,
    sohniJunejaIsARe3,
    offers,
    rectangle133,
    asMakeupPlaysAnI4,
    sohniJunejaIsARe4,
    hairstylingOnProps,
    bridalMakeup1Props,
    partyMakeupProps,
    bridalMakeupOnProps,
    bridalMakeup2Props,
    offers1Props,
    group2221Props,
    hairStyling1Props,
    bridalMakeup3Props,
    partyMakeupOnProps,
    offers2Props,
    hairStyling2Props,
    bridalMakeup4Props,
    bridalMakeup5Props,
    offersOnProps,
    group2222Props,
  } = props;

  return (
    <div className="services-2">
      <div className="service-1">
        <div className="group-29">
          <HairstylingOn hairStyling={hairstylingOnProps.hairStyling} />
          <BridalMakeup>{bridalMakeup1Props.children}</BridalMakeup>
          <PartyMakeup>{partyMakeupProps.children}</PartyMakeup>
          <Offers />
        </div>
        <div className="overlap-group1-5 border-1-5px-gray">
          <div className="hair-styling poppins-medium-tundora-14px">{hairStyling}</div>
          <div className="flex-row-13">
            <img className="rectangle-115" src={rectangle115} />
            <p className="as-makeup-plays-an-i-1 montserrat-normal-tundora-10px">{asMakeupPlaysAnI1}</p>
          </div>
          <div className="overlap-group2-4">
            <p className="sohni-juneja-is-a-re montserrat-normal-tundora-10px">{sohniJunejaIsARe1}</p>
            <Group222 />
          </div>
        </div>
      </div>
      <div className="service-2">
        <div className="group-29-1">
          <HairStyling />
          <BridalMakeupOn polygon33={bridalMakeupOnProps.polygon33} bridalMakeup={bridalMakeupOnProps.bridalMakeup} />
          <BridalMakeup className={bridalMakeup2Props.className}>{bridalMakeup2Props.children}</BridalMakeup>
          <Offers className={offers1Props.className} />
        </div>
        <div className="overlap-group3 border-1-5px-gray">
          <div className="bridal-makeup poppins-medium-tundora-14px">{bridalMakeup}</div>
          <div className="flex-row-12">
            <img className="rectangle-1" src={rectangle121} />
            <p className="as-makeup-plays-an-i montserrat-normal-tundora-10px">{asMakeupPlaysAnI2}</p>
          </div>
          <div className="overlap-group1-4">
            <p className="sohni-juneja-is-a-re montserrat-normal-tundora-10px">{sohniJunejaIsARe2}</p>
            <Group222 className={group2221Props.className} />
          </div>
        </div>
      </div>
      <div className="service-3">
        <div className="group-29">
          <HairStyling className={hairStyling1Props.className} />
          <BridalMakeup className={bridalMakeup3Props.className}>{bridalMakeup3Props.children}</BridalMakeup>
          <PartyMakeupOn polygon34={partyMakeupOnProps.polygon34} partyMakeup={partyMakeupOnProps.partyMakeup} />
          <Offers className={offers2Props.className} />
        </div>
        <div className="overlap-group-8 border-1-5px-gray">
          <div className="party-makeup poppins-medium-tundora-14px">{partyMakeup}</div>
          <div className="flex-row-12">
            <img className="rectangle-1" src={rectangle127} />
            <p className="as-makeup-plays-an-i montserrat-normal-tundora-10px">{asMakeupPlaysAnI3}</p>
          </div>
          <div className="overlap-group1-4">
            <p className="sohni-juneja-is-a-re montserrat-normal-tundora-10px">{sohniJunejaIsARe3}</p>
            <Group222 />
          </div>
        </div>
      </div>
      <div className="service-4">
        <div className="group-29-1">
          <HairStyling className={hairStyling2Props.className} />
          <BridalMakeup className={bridalMakeup4Props.className}>{bridalMakeup4Props.children}</BridalMakeup>
          <BridalMakeup className={bridalMakeup5Props.className}>{bridalMakeup5Props.children}</BridalMakeup>
          <OffersOn polygon35={offersOnProps.polygon35} offers={offersOnProps.offers} />
        </div>
        <div className="overlap-group-8 border-1-5px-gray">
          <div className="offers poppins-medium-tundora-14px">{offers}</div>
          <div className="flex-row-12">
            <img className="rectangle-1" src={rectangle133} />
            <p className="as-makeup-plays-an-i montserrat-normal-tundora-10px">{asMakeupPlaysAnI4}</p>
          </div>
          <div className="overlap-group1-4">
            <p className="sohni-juneja-is-a-re montserrat-normal-tundora-10px">{sohniJunejaIsARe4}</p>
            <Group222 className={group2222Props.className} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Property1Default;
